import { MENU_CODE } from '~/constants/menu'

export const usePromotionSection = () => {
  const eventName: string = 'click_promotion_home'
  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const { getPath } = useNavigationMenu()

  const eventHomePromotion = (promotion: string) => {
    analyticEvent({
        ga4ActionName: 'click_promotion_home',
        ga4Label: promotion,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Promotion - Home',
      fbValue: { label: promotion },
    })
  }

  return {
    MENU_CODE,
    eventName,
    eventHomePromotion,
    getPath,
  }
}
